import {TheBorderFreeSpinWinPresentation} from "../freespin/TheBorderFreeSpinWinPresentation";
import {TheBorderXWaysWinRunner} from "../../presentationrunners/general/TheBorderXWaysWinRunner";
import {TheBorderXSplitWinRunner} from "../../presentationrunners/general/TheBorderXSplitWinRunner";
import {TheBorderXNudgeWinRunner} from "../../presentationrunners/general/TheBorderXNudgeWinRunner";
import {TheBorderFreeSpinOutroRunner} from "../../presentationrunners/freespin/TheBorderFreeSpinOutroRunner";
import {TheBorderSpinEndRunner} from "../../presentationrunners/general/TheBorderSpinEndRunner";
import {TheBorderTotalWinRunner} from "../../presentationrunners/general/TheBorderTotalWinRunner";
import {TheBorderBigWinRunner} from "../../presentationrunners/general/TheBorderBigWinRunner";
import {
    TheBorderSuperFSAvalancheWinRunner
} from "../../presentationrunners/superfreespin/TheBorderSuperFSAvalancheWinRunner";
import {TheBorderMaxWinRunner} from "../../presentationrunners/general/TheBorderMaxWinRunner";
import {TheBorderXClusterRunner} from "../../presentationrunners/general/TheBorderXClusterRunner";

/**
 * Created by Jerker Nord on 2022-06-30.
 */

export class TheBorderSuperFSWinPresentation extends TheBorderFreeSpinWinPresentation {

    constructor() {
        super();
        this._presentations = [
            new TheBorderXWaysWinRunner(),
            new TheBorderXSplitWinRunner(),
            new TheBorderXNudgeWinRunner(),
            new TheBorderXClusterRunner(),
            new TheBorderSuperFSAvalancheWinRunner(),
            new TheBorderMaxWinRunner(),
            new TheBorderSpinEndRunner(),
            new TheBorderTotalWinRunner(),
            new TheBorderBigWinRunner(),
            new TheBorderFreeSpinOutroRunner()
        ];
    }
}